<template>
    <div style2="width:600px;">
        <div class="flex flex-wrap items-center justify-between mb-3">
            <div>
                <h3 class="text-2xl">Product Stock Alerts</h3>
            </div>
            <!-- <div>
                <router-link :to="{name: 'subscriptions'}" class="text-blue-500">
                    Manage Subscriptions
                </router-link>
            </div> -->
        </div>

        <h5 class="mb-3 text-gray-600">
            We'll notify you when this product is back in stock.
        </h5>

        <hr class="py-3">

        <div v-if="errors.any()">
            <div class="bg-red-200 text-red-800 py-2 px-3 text-center rounded mb-3">
                There was an error submitting the form.
            </div>
        </div>

        <div v-if="complete">
            <div class="bg-green-200 text-green-800 py-4 px-3 text-center rounded">
                Your notification has been registered.
            </div>
            <!-- <div class="bg-red-200 text-red-800 py-4 px-3 text-center rounded">
                You have already registered for a notification for that item.
            </div> -->
        </div>

        <form v-else @submit.prevent="submit" :disabled="loading" action="#">
            <div class="flex mb-4">
                <button @click="channel = 'email'" type="button" :class="{'bg-green-500 text-white' : channel === 'email', 'bg-gray-300 border-gray-400 border-r' : channel !== 'email'}" class="w-1/3 font-medium py-2 focus:outline-none rounded-tl rounded-bl">Email Me</button>
                <button @click="channel = 'sms'" type="button" :class="{'bg-green-500 text-white' : channel === 'sms', 'bg-gray-300 border-gray-400 border-r' : channel !== 'sms'}" class="w-1/3 font-medium py-2 focus:outline-none">Text (SMS)</button>
                <button @click="channel = 'web'" type="button" :class="{'bg-green-500 text-white' : channel === 'web', 'bg-gray-300 border-gray-400' : channel !== 'web'}" class="w-1/3 font-medium py-2 focus:outline-none rounded-tr rounded-br">Web Push</button>
            </div>

            <div v-if="channel === 'email'">
                <input :class="{ 'border-red-400': hasError('email') }" :disabled="loading" type="email" name="email" v-model="email" placeholder="Email address" class="block w-full py-2 px-3 text-base font-normal leading-normal text-gray-700 bg-white border-2 border-gray-400 border-solid rounded outline-none mb-4 focus:border-gray-600" autocomplete="email" required />
            </div>
            <div v-else-if="channel === 'sms'">
                <input :class="{ 'border-red-400': hasError('phone') }" :disabled="loading" type="text" name="phone" v-model="phone" placeholder="Phone number" class="block w-full py-2 px-3 text-base font-normal leading-normal text-gray-700 bg-white border-2 border-gray-400 border-solid rounded outline-none mb-4 focus:border-gray-600" autocomplete="phone" required />
            </div>
            <div v-else-if="channel === 'web'">
                <div class="mb-5 bg-orange-200 py-2 rounded">
                    <p class="text-center text-gray-700">
                        This feature is coming soon!
                    </p>
                </div>
            </div>

            <div v-if="channel === 'email' || channel === 'sms'">
                <button :disabled="loading" type="submit" class="rounded bg-green-500 text-white py-2 text-xl font-medium w-full focus:outline-none">
                    Save Notification
                </button>

                <small class="text-xs text-gray-600 text-left py-4 block">
                    We don't share your information with others.
                </small>
            </div>
        </form>
    </div>
</template>

<script>
import { Errors } from 'form-backend-validation';

/**
 * @see https://medium.com/javascript-in-plain-english/many-ways-to-rerender-a-vue-component-660376d94cc1
 */
export default {
    data: () => ({
        complete: false,
        loading: false,
        // error: false,
        // message: null,
        channel: 'email',
        email: null,
        phone: null,
        errors: new Errors()
    }),

    created() {
        // check cookie if already submitted?
    },

    mounted() {
        this.$nextTick(() => {
            if ('parentIFrame' in window) {
                parentIFrame.size(350, 600);
                // parentIFrame.size(300, 400);
            }
        });
    },

    computed: {},

    methods: {
        hasError(field) {
            return this.errors.has(field);
        },

        firstError(field) {
            if (this.hasError(field)) {
                return this.errors.first(field);
            }
        },

        submit() {
            if (this.loading) {
                return;
            }

            this.errors = new Errors();
            this.complete = false;
            // this.error = false;
            // this.message = null;

            const payload = {
                channel: this.channel,
                email: this.email,
                phone: this.phone,
                product_id: window.App.product_id,
                variant_id: window.App.variant_id
            };

            /*fetch('/api/widget/subscribe', {
                method: 'POST',
                body: JSON.stringify(payload)
            })*/
            axios.post('/api/widget/subscribe', payload)
                .then(response => {
                    const notification = response.data;
                    // if (result.status === 'success') {
                        this.complete = true;
                    // } else {
                    //     this.error = true;
                    // }
                })
                .catch(err => {
                    // console.error(err);
                    const response = err.response;
                    if (response.status === 422) {
                        this.errors = new Errors(response.data.errors);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
